// import React from 'react'

// const AdminApproval = () => {
//   return (
//     <div>AdminApproval</div>
//   )
// }

// export default AdminApproval



import { useEffect, useState } from 'react';
import axios from 'axios';

const AdminApproval = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');

    const API_URL = 'https://api.nfcdesignstudio.com/API/v1'; // Match your backend URL

    // Fetch all pending users on load
    const fetchPendingUsers = async () => {
        try {
            const response = await axios.get(`${API_URL}/pending-users`);
            setUsers(response.data);
        } catch (err) {
            console.error('Error fetching pending users:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPendingUsers();
    }, []);

    // Approve User
    const handleApprove = async (email) => {
        try {
            await axios.get(`${API_URL}/approve?email=${encodeURIComponent(email)}`);
            setMessage(`User ${email} approved successfully.`);
            fetchPendingUsers(); // Refresh list
        } catch (err) {
            alert('Failed to approve user.');
        }
    };

    // Reject User
    const handleReject = async (email) => {
        try {
            await axios.get(`${API_URL}/reject?email=${encodeURIComponent(email)}`);
            setMessage(`User ${email} rejected.`);
            fetchPendingUsers(); // Refresh list
        } catch (err) {
            alert('Failed to reject user.');
        }
    };

    if (loading) return <p style={{ textAlign: 'center', marginTop: '20px' }}>Loading pending users...</p>;

    return (
        <div style={{ maxWidth: '850px', margin: '40px auto', padding: '20px', fontFamily: 'Arial', boxShadow: '0 0 10px rgba(0,0,0,0.1)', borderRadius: '8px' }}>
            <h2>Admin Approval Dashboard</h2>
            <p>Manage new user registration requests pending review.</p>

            {message && <p style={{ backgroundColor: '#e6ffe6', color: 'green', padding: '10px', borderRadius: '4px' }}>{message}</p>}

            {users.length === 0 ? (
                <p style={{ marginTop: '20px', fontStyle: 'italic', color: '#666' }}>No pending user requests found.</p>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                            <th style={{ padding: '12px', textAlign: 'left' }}>Username</th>
                            <th style={{ padding: '12px', textAlign: 'left' }}>Email</th>
                            <th style={{ padding: '12px', textAlign: 'left' }}>Mobile</th>
                            <th style={{ padding: '12px', textAlign: 'center' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                                <td style={{ padding: '12px' }}>{user.username}</td>
                                <td style={{ padding: '12px' }}>{user.email}</td>
                                <td style={{ padding: '12px' }}>{user.mobile}</td>
                                <td style={{ padding: '12px', textAlign: 'center', display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                    <button
                                        onClick={() => handleApprove(user.email)}
                                        style={{ backgroundColor: '#28a745', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '4px', cursor: 'pointer' }}
                                    >
                                        Approve
                                    </button>
                                    <button
                                        onClick={() => handleReject(user.email)}
                                        style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '6px 14px', borderRadius: '4px', cursor: 'pointer' }}
                                    >
                                        Reject
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default AdminApproval // or export default AdminApproval; depending on your setup